export default function init_customCursor() {
  const cursorEl = document.getElementById("custom-cursor");
  if (!cursorEl) return;

  ////////////// Setup ///////////////
  ////////////////////////////////////

  let mouseX = 0,
    mouseY = 0;
  let currentX = 0,
    currentY = 0;

  //////////// Event hdl. ////////////
  ////////////////////////////////////

  document.addEventListener("mousemove", function (e) {
    // Only update cursor position on screens larger than 550px
    if (window.innerWidth > 550) {
      mouseX = e.clientX;
      mouseY = e.clientY;
    }

    // Cursor highlight when hovering specific elements
    const target = e.target;
    const shouldHighlight =
      target.tagName === "A" || target.closest("a") || target.dataset.highlightCursor === "true" || target.closest("[data-highlight-cursor='true']") || target.dataset.cursorHighlight === "true";

    // Cursor highlight color updt. //
    // Check if highlight-trigger el. has color for cursor
    if (shouldHighlight) {
      let highlightColor = null;
      if (target.dataset.cursorHighlightColor) {
        highlightColor = target.dataset.cursorHighlightColor;
      } else {
        const highlightEl = target.closest("[data-color-cursor-highlight]");
        if (highlightEl) highlightColor = highlightEl.dataset.colorCursorHighlight;
      }
      if (highlightColor) {
        cursorEl.style.setProperty("--c-highlight", highlightColor);
      } else {
        // Reset to default highlight color
        cursorEl.style.setProperty("--c-highlight", "var(--color-cef-red)");
      }
    } else {
      // Reset to default highlight color
      cursorEl.style.setProperty("--c-highlight", "var(--color-cef-red)");
    }

    // Set highlight state
    cursorEl.dataset.highlight = shouldHighlight ? "true" : "false";
  });

  ////// Cursor position anim. ///////
  ////////////////////////////////////

  function animate() {
    // Only animate cursor on screens larger than 550px
    if (window.innerWidth > 550) {
      // Smooth following with slight delay
      currentX += (mouseX - currentX) * 0.4;
      currentY += (mouseY - currentY) * 0.4;

      cursorEl.style.left = currentX + "px";
      cursorEl.style.top = currentY + "px";
    }
    requestAnimationFrame(animate);
  }

  animate();
}
